const OPAQUE_BASES = /* @__PURE__ */ new Set(["about:srcdoc", "about:blank"]);
function resolveBase(base, fallback) {
  if (base === void 0 || base === null) {
    return base;
  }
  return OPAQUE_BASES.has(String(base)) ? fallback : base;
}
function createPatchedUrl(NativeURL, fallback = "http://localhost/") {
  return class PatchedURL extends NativeURL {
    constructor(url, base) {
      super(url, resolveBase(base, fallback));
    }
    static parse(url, base) {
      return NativeURL.parse(url, resolveBase(base, fallback));
    }
    static canParse(url, base) {
      return NativeURL.canParse(url, resolveBase(base, fallback));
    }
  };
}
export {
  createPatchedUrl
};
//# sourceMappingURL=patch-iframe-url.js.map
